import { options } from "../../data/group-insurance";
import { PaginationValue } from "./pagination-state";

export interface TotalPages {
    id: number;
    value: number;
    name: string;
}

export const totalPages: TotalPages[] = [
    { id: 20, value: 20, name: '20', },
    { id: 40, value: 40, name: '40', },
    { id: 60, value: 60, name: '60', },
    { id: 80, value: 80, name: '80', },
    { id: 100, value: 100, name: '100', },
    { id: 200, value: 200, name: '200', },
]

export const getBookedProposalPaginationValueInitialState = (): PaginationValue => ({
    searchType: options[0],
    searchValue: "",
    page: 1,
    pageSize: 20,
    isTyping: false,
    defaultTotalPages: totalPages[0],
    isPageSizeChanging: false,
    isDebounceDone: false,
});

export const getAllProposalPaginationValueInitialState = (): PaginationValue => ({
    searchType: options[0],
    searchValue: "",
    page: 1,
    pageSize: 20,
    isTyping: false,
    defaultTotalPages: totalPages[0],
    isPageSizeChanging: false,
    isDebounceDone: false,
});

export const getComputationApprovalPaginationValueInitialState = (): PaginationValue => ({
    searchType: options[0],
    searchValue: "",
    page: 1,
    pageSize: 20,
    isTyping: false,
    defaultTotalPages: totalPages[0],
    isPageSizeChanging: false,
    isDebounceDone: false,
});

export const getAllComputationApprovalPaginationValueInitialState = (): PaginationValue => ({
    searchType: options[0],
    searchValue: "",
    page: 1,
    pageSize: 20,
    isTyping: false,
    defaultTotalPages: totalPages[0],
    isPageSizeChanging: false,
    isDebounceDone: false,
});

export const getAllConflictProposalForApprovalValueInitialState = (): PaginationValue => ({
    searchType: options[0],
    searchValue: "",
    page: 1,
    pageSize: 20,
    isTyping: false,
    defaultTotalPages: totalPages[0],
    isPageSizeChanging: false,
    isDebounceDone: false,
});

export const getAllProposalOfUserValueInitialState = (): PaginationValue => ({
    searchType: options[0],
    searchValue: "",
    page: 1,
    pageSize: 20,
    isTyping: false,
    defaultTotalPages: totalPages[0],
    isPageSizeChanging: false,
    isDebounceDone: false,
});